import React from 'react'

export interface ApolloQueueContextValue {
  processing: boolean
  lastProcess: number
  pendingCount: number
}

export const ApolloQueueContext = React.createContext<ApolloQueueContextValue>({
  processing: false,
  lastProcess: 0,
  pendingCount: 0
})
